<template>
  <!-- Case name and labels -->
  <v-row>
    <v-col cols="auto">
      <v-row>
        <v-col v-if="selectedCase.type"
          cols="auto"
          align-self="center">
          <v-icon large>{{ getIconForType(selectedCase.type) }}</v-icon>
        </v-col>
        <v-col>
          <span class="text-h5">{{ selectedCase.name }}</span>
          <span v-if="selectedCase.title"
            class="font-weight-light"><br />{{ selectedCase.title }}</span>
        </v-col>
      </v-row>
    </v-col>

    <v-divider vertical />
    <v-col>
      <v-row dense>
        <!-- <v-col>
            <div class="overline">Veriscan ID</div>
            <code>{{ selectedCase.id }}</code>
          </v-col> -->
        <v-col v-if="selectedCase.localId">
          <div class="overline">ID</div>
          {{ selectedCase.localId }}
        </v-col>
        <v-col v-if="selectedCase.caseGroupId">
          <div class="overline">Case Group</div>
          {{ getCaseGroupName(selectedCase.caseGroupId) }}
        </v-col>
        <v-col cols="auto">
          <span class="overline">Created </span>
          <span class="text-body-2">{{ formatDateTime(selectedCase.createdOn) }}</span>
          <template v-if="selectedCase.modifiedOn">
            <br />
            <span class="overline">Modified </span>
            <span class="text-body-2">{{ `${formatDateTime(selectedCase.modifiedOn)} by ${selectedCase.modifiedBy}` }}</span>
          </template>
          <template v-if="selectedCase.lastScreenDate">
            <br />
            <span class="overline">Last Screened </span>
            <span class="text-body-2">{{ formatDateTime(selectedCase.lastScreenDate) }}</span>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <!-- Custom labels -->
        <v-col aria-colspan="" v-for="(value, propertyName) in selectedCase.customLabels"
          :key="propertyName"
          cols="auto">
          <span class="overline">{{ propertyName }}: </span>
          {{ value }}
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import { formatDateTime } from "../../utils/dateUtils";
  import { getCaseGroupName } from "../../utils/caseGroupUtils";
  export default {
    name: "CaseHeader",
    data() {
      return {};
    },
    created(){
    },
    props: {
      selectedCase: {}
    },
    computed: {
      // ...mapGetters(["getCaseGroups", "users"]),
    },
    methods: {
      formatDateTime,
      getCaseGroupName,
      getIconForType(type) {
        //fa-user, fa-building, fa-ship
        if ('person'.includes(type.toLowerCase())) {
          return 'fa-user'
        } else if ('organization'.includes(type.toLowerCase())) {
          return 'fa-building'
        } else if ('vessel'.includes(type.toLowerCase())) {
          return 'fa-ship'
        }
      },
    }
  };
</script>